import React, { useState, useEffect, useRef } from 'react';
import { DRIVERS_SEARCH_ENDPOINT } from '../../../config/urls';
import { useAuth } from "../../../hooks/AuthProvider";
import TableAutocomplete from '../../../common/table-autocomplete';

const URL = DRIVERS_SEARCH_ENDPOINT;

const SearchInput = ({ updateSearchValue }) => {
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const { getValidToken } = useAuth();
  const latestQuery = useRef('');

  const handleInputChange = (event, value, reason) => {
    setQuery(value);
    // 'reset' fires when an option is picked; the text is the option label, not a new search.
    if (reason === 'reset') return;
    if (value === '') {
      updateSearchValue('');
    } else {
      fetchSearchResults(value);
    }
  };

  const handleOptionSelect = (event, value) => {
    if (value && value.id) {
      updateSearchValue(value.id);
    }
  };

  const fetchSearchResults = async (searchQuery) => {
    latestQuery.current = searchQuery;
    setLoading(true);
    try {
      const token = await getValidToken();
      const tenant = localStorage.getItem('tenant');
      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        'X-Tenant-Id': tenant,
      };
      const response = await fetch(`${URL}?search_value=${encodeURIComponent(searchQuery)}`, { headers });
      const data = await response.json();
      // Drop responses for older keystrokes that arrive after newer ones.
      if (latestQuery.current === searchQuery) setOptions(data.results || []);
    } catch (error) {
      console.error('Error fetching search results:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!open) setOptions([]);
  }, [open]);

  return (
    <TableAutocomplete
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      inputValue={query}
      onInputChange={handleInputChange}
      onChange={handleOptionSelect}
      options={options}
      loading={loading}
      getOptionLabel={(option) => `${option.name} (${option.phone_no})`}
      isOptionEqualToValue={(option, value) => option.name === value.name}
      tooltip="Search driver's name or phone"
      placeholder="Search driver's name or phone"
      sx={{ width: { xs: '100%', sm: 340 } }}
      renderOption={(props, option) => (
        <li {...props}>
          <div>
            <strong>{option.name}</strong>
            <br />
            <small>Phone: {option.phone_no}</small>
          </div>
        </li>
      )}
    />
  );
};

export default SearchInput;